import api from './api'

const productDataProvider = {
  addMiniProduct(params) {
    return api.post('Product/api/Product/AddProduct', params)
  },
  getCategories() {
    return api.get('Product/api/Product/GetAllCategories')
  },
  getProductDetail(params) {
    return api.query(`Product/api/Product/GetProductByIdForAdmin/${params}`)
  },
  updateProduct(params) {
    return api.put('Product/api/Product/EditProduct', params)
  },
}

export default productDataProvider
